import React, { useContext } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";

const Constant = () => {
  const { t } = useContext(LanguageContext);
  const niches = [
    {
      value: 1,
      title: t("General"),
      content: <i className="bi-file-earmark-richtext"></i>,
    },
    {
      value: 2,
      title: t("Gambling"),
      content: <i className="bi bi-dice-5"></i>,
    },
    {
      value: 3,
      title: t("Crypto"),
      content: <i className="bi bi-currency-bitcoin"></i>,
    },
    {
      value: 4,
      title: t("Medications"),
      content: <i className="bi bi-capsule"></i>,
    },
    {
      value: 5,
      title: t("Dating"),
      content: <i className="bi bi-chat-left-heart"></i>,
    },
    {
      value: 6,
      title: t("Adult"),
      content: <span style={{ fontSize: "9px" }}>18+</span>,
    },
  ];

  const languageOptions = {
    1: t("Arabic"),
    2: t("Bulgarian"),
    3: t("Chinese"),
    4: t("Dutch"),
    5: t("English"),
    6: t("French"),
    7: t("German"),
    8: t("Greek"),
    9: t("Hindi"),
    10: t("Hrvatski"),
    11: t("Indonesian"),
    12: t("Italian"),
    13: t("Japanese"),
    14: t("Korean"),
    15: t("Norwegian"),
    16: t("Other"),
    17: t("Polish"),
    18: t("Portuguese"),
    19: t("Romanian"),
    20: t("Russian"),
    21: t("Spanish"),
    22: t("Swedish"),
    23: t("Turkish"),
    24: t("Ukrainian"),
  };

  const contractStatusType = {
    0: {
      title: t("Draft"),
      class: "custom-text-gray bg-soft-secondary",
      contractClass: "custom-text-gray",
    },
    1: {
      title: t("Waiting Acceptance"),
      class: "text-warning bg-softer-warning",
      contractClass: "text-warning",
    },
    3: {
      title: t("Declined"),
      class: "text-declined bg-declined",
      contractClass: "text-declined",
    },
    5: {
      title: t("Online"),
      class: "text-success bg-soft-success",
      contractClass: "text-success",
    },
    6: {
      title: t("In Progress"),
      class: "text-primary bg-soft-primary",
      contractClass: "text-primary",
    },
    7: {
      title: t("Deleted"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    8: {
      title: t("In Cart"),
      class: "text-info bg-soft-primary",
      contractClass: "text-info",
    },
    9: {
      title: t("Corrupted"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
  };

  const categoryOptions = {
    1: t("Agriculture"),
    2: t("Animals and Pets"),
    3: t("Art"),
    4: t("Automobiles"),
    5: t("Business"),
    6: t("Books"),
    7: t("Beauty"),
    8: t("Career and Employment"),
    9: t("Computers"),
    10: t("Construction and Repairs"),
    11: t("Culture"),
    12: t("E-commerce"),
    13: t("Education"),
    14: t("Entertainment"),
    15: t("Environment"),
    16: t("Equipment"),
    17: t("Fashion"),
    18: t("Finance"),
    19: t("Food"),
    20: t("For Children"),
    21: t("For Men"),
    22: t("For Women"),
    23: t("Gadgets"),
    24: t("Games"),
    25: t("Hardware development"),
    26: t("Health"),
    27: t("Technology"),
    28: t("Home and Family"),
    29: t("Humor"),
    30: t("Internet"),
    31: t("Law"),
    32: t("Leisure and Hobbies"),
    33: t("Lifestyle"),
    34: t("Literature"),
    35: t("Manufacturing"),
    36: t("Marketing and Advertising"),
    37: t("Miscellaneous"),
    38: t("Mobile"),
    39: t("Movies"),
    40: t("Music"),
    41: t("Nature"),
    42: t("News and Media"),
    43: t("Personal Blogs"),
    44: t("Photography"),
    45: t("Places"),
    46: t("Politics"),
    47: t("Programming"),
    48: t("Public Service"),
    49: t("Real Estate"),
    50: t("Science"),
    51: t("Shopping"),
    52: t("Society"),
    53: t("Software development"),
    54: t("Sports"),
    55: t("Startups"),
    56: t("Travelling"),
    57: t("Transport"),
    58: t("Web-development"),
  };

  const importStatus = {
    100: {
      title: t("Pending"),
      class: "badge bg-soft-secondary text-secondary",
    },
    101: {
      title: t("Processing"),
      class: "badge bg-soft-primary text-primary",
    },
    102: {
      title: t("Completed"),
      class: "badge bg-soft-success text-success",
    },
  };

  const parsingProcess = {
    0: {
      title: t("Not Started"),
      class: "badge bg-soft-secondary text-secondary",
    },
    1: {
      title: t("Successful"),
      class: "badge bg-soft-success text-success",
    },
    2: {
      title: t("Failed"),
      class: "badge text-danger bg-soft-danger",
      icon: <i class="bi bi-question-circle"></i>,
    },
  };

  const productType = {
    100: t("Backlinks"),
  };

  const importType = {
    101: t("Backlinks Terms"),
    102: t("Backlinks Offers"),
  };

  const recordStatusType = {
    0: {
      title: t("Pending Review"),
      class: "text-warning bg-soft-warning",
      contractClass: "text-warning",
    },
    1: {
      title: t("Declined"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    2: {
      title: t("Approved"),
      class: "text-success bg-soft-success",
      contractClass: "text-success",
    },
    3: {
      title: t("All"),
      class: "text-primary bg-soft-primary",
      contractClass: "text-primary",
    },
  };

  const ordersStatus = {
    0: {
      title: t("In Progress"),
      class: "text-primary bg-soft-primary",
      contractClass: "text-primary",
    },
    3: {
      title: t("Paid"),
      class: "text-success bg-soft-success",
      contractClass: "text-success",
    },
    1: {
      title: t("Abandoned"),
      class: "text-declined bg-declined",
      contractClass: "text-declined",
    },
  };

  const placementItems = {
    1: t("Guest Post"),
    2: t("Link Insert"),
    3: t("Niche Edit"),
  };

  const statusType = {
    100: {
      title: t("Pending"),
      class: "text-warning bg-soft-warning",
      contractClass: "text-warning",
    },
    103: {
      title: t("Error"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    102: {
      title: t("Completed"),
      class: "text-success bg-soft-success",
      contractClass: "text-success",
    },
    101: {
      title: t("Processing"),
      class: "text-primary bg-soft-primary",
      contractClass: "text-primary",
    },
  };

  const linkTypeItems = {
    1: t("Do Follow"),
    2: t("No Follow"),
    3: t("Sponsored"),
  };

  const themeStatus = {
    default: "light-mode",
    dark: "dark-mode",
    auto: "default-mode",
  };

  const paymentMethodTypes = {
    balance: 1,
    addCard: 2,
    card: 2,
    paypal: 3,
    google: 4,
    apple: 5,
  };

  const placementData = [
    {
      id: 1,
      heading: t("Page Availability"),
      inputs: [
        {
          id: 11,
          title: t("Page Available"),
        },
        {
          id: 12,
          title: t("Access for Robots Allowed"),
        },
      ],
    },
    {
      id: 2,
      heading: t("Page Indexation"),
      inputs: [
        {
          id: 21,
          title: t("Meta Allows Indexing"),
        },
        {
          id: 22,
          title: t("Headers Allows Indexing"),
        },
      ],
    },
    {
      id: 3,
      heading: t("Links Following Allowed"),
      inputs: [
        {
          id: 31,
          title: t("Meta Allows Link Following"),
        },
        {
          id: 32,
          title: t("Headers Allows Link Following"),
        },
      ],
    },
    {
      id: 4,
      heading: t("Links Found"),
      inputs: [
        {
          id: 41,
          title: t("desktop alerts"),
        },
        {
          id: 42,
          title: t("employee app"),
        },
      ],
    },
  ];

  const statusOptions = [
    { label: t("Actual"), value: 1 },
    { label: t("Not Actual"), value: 666 },
    { label: t("Page not found"), value: 2 },
    { label: t("Backlink(s) not found"), value: 3 },
    { label: t("Backlink type(s) changed"), value: 4 },
    { label: t("Page with a `noindex` meta tag"), value: 5 },
    { label: t("Page with a `nofollow` meta tag"), value: 6 },
    { label: t("Page with a `none` meta tag"), value: 7 },
    { label: t("Page 'disallowed' in a robots.txt"), value: 8 },
    { label: t("Link's anchor changed"), value: 9 },
    { label: t("Page with 'noindex' in the 'X-Robots-Tag' header"), value: 10 },
    {
      label: t("Page with 'nofollow' in the 'X-Robots-Tag' header"),
      value: 11,
    },
    { label: t("Page with 'none' in the 'X-Robots-Tag' header"), value: 12 },
  ];

  const relOptions = [
    {
      label: t("Do Follow"),
      value: 1,
    },
    {
      label: t("No Follow"),
      value: 2,
    },
    {
      label: t("Sponsored"),
      value: 3,
    },
  ];

  return {
    niches,
    languageOptions,
    contractStatusType,
    categoryOptions,
    importStatus,
    statusOptions,
    relOptions,
    parsingProcess,
    productType,
    importType,
    recordStatusType,
    statusType,
    linkTypeItems,
    ordersStatus,
    placementItems,
    paymentMethodTypes,
    themeStatus,
    placementData,
  };
};

export default Constant;
